import MP4Box from 'mp4box';

async function createMp4BoxFile(file) {
  return new Promise((resolve, reject) => {
    const mp4boxFile = MP4Box.createFile();
    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = function (e) {
      const arrayBuffer = e.target.result;
      arrayBuffer.fileStart = 0;
      mp4boxFile.appendBuffer(arrayBuffer);
    };

    mp4boxFile.onReady = function (info) {
      resolve(info);
    };

    mp4boxFile.onError = function (info) {
      reject(info);
    };
  });
}

async function videoFileProcessor(file) {
  const fileInfo = await createMp4BoxFile(file);
  return fileInfo;
}

export default videoFileProcessor;
